import React, { createContext, useContext } from "react";
import ar from "./ar";

const dictionaries = { ar };

const I18nContext = createContext({ lang: "ar", dir: "rtl", t: (k) => k });

export function I18nProvider({ children, lang = "ar" }) {
  const dict = dictionaries[lang] || ar;
  const dir = lang === "ar" ? "rtl" : "ltr";
  const t = (key) => (dict[key] !== undefined ? dict[key] : key);
  return (
    <I18nContext.Provider value={{ lang, dir, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
